import { getAnalytics, logEvent as log } from 'firebase/analytics';
import { useFirebaseStore } from '../store/Firebase';

export const useAnalytics = () => {
  const { firebaseApp } = useFirebaseStore();

  const MAX_EVENT_NAME_SIZE = 40;

  const logEvent = (props: { eventName: string; eventParams: any }) => {
    if (props.eventName.length > MAX_EVENT_NAME_SIZE) {
      console.error('🚀 ~ file: useAnalytics.ts:11 ~ logEvent ~ maximum event name size name exceeded');
      return;
    }

    if (firebaseApp?.()) {
      const analytics = getAnalytics(firebaseApp());
      if (analytics) log(analytics, props.eventName, props.eventParams);
    }
  };

  return { logEvent };
};
